import React, { Component } from "react";
import { Card, CustomInput, Badge } from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import { AddCommaNumber } from "../../../helpers/Utils";
import moment from "moment";
import classNames from "classnames";
import IntlMessages from "../../../helpers/IntlMessages";

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };

  // onClickedItem = (item) => {
  //     this.props.onClickedItem(
  //         // callback
  //         item,
  //         this.menuButtonClick,
  //         [null, 1000, this.props.containerClassnames]
  //     );
  // };

  render() {
    const { dropdownSplitOpen } = this.state;
    const {
      idx,
      countLengthMakeProduct,
      selectedItems,
      item,
      onChangeCheckbox,
      isDisabledUpdate,
      onUpdate,
      onUpdateCount,
      isDisabledDelete,
      onDelete,
      onClickedItem,
    } = this.props;
    // console.log('countLengthMakeProduct', countLengthMakeProduct);

    return (
      <Card
        className={classNames("mb-3 custom-shadow", {
          active: selectedItems.includes(item.id),
        })}
      >
        <div className="d-flex flex-row cursor-pointer">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            <div
              onClick={(e) => {
                onClickedItem(item, e);
              }}
              className="card-body w-100 d-flex align-items-center justify-content-between py-3"
            >
              <div className="align-self-center d-flex flex-column justify-content-between">
                <div className="d-flex align-items-center list-item-heading truncate d-block">
                  {item.isTemplate ? (
                    <Badge color="info" pill className="mr-1" style={{ fontSize: "0.65rem" }}>
                      <IntlMessages id="template.badge" />
                    </Badge>
                  ) : null}
                  {item.name}
                </div>
                <div className="text-muted text-small">
                  Được sử dụng cho {countLengthMakeProduct} sản phẩm
                </div>
                <div className="text-muted text-small mt-3">
                  Còn lại: {item.count} {item.unit} / Tổng nhập: {item.total}{" "}
                  {item.unit}
                </div>
              </div>
              <div className="align-self-center d-flex flex-column justify-content-between">
                <Badge pill color="primary">
                  Giá vốn: {AddCommaNumber(parseInt(item.price_new))}{" "}
                  {item.unit && `/ ${item.unit}`}
                </Badge>
                <div className="mt-3 text-muted text-small">
                  Ngày tạo: {moment(item.createdAt).format("DD/MM/YYYY")}
                </div>
              </div>
            </div>
            {/* Simple Checkbox - like Product cards */}
            <div
              className="custom-control custom-checkbox align-self-center"
              style={{
                padding: "15px 20px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onChangeCheckbox(item.id, e);
              }}
            >
              <CustomInput
                type="checkbox"
                id={`check-stock-${item.id}`}
                label=""
                checked={selectedItems.includes(item.id)}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
